<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard_adv/normal" >
      RocketBees
      </b-link>    
        
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/adminuser_mr" v-if=" systemUserid === 1" >Admin user </b-nav-item>
        <b-nav-item class="px-3" to="/coordinator_user" v-if=" systemUserid === 2" >Coordinator User </b-nav-item>
        <!-- <b-nav-item class="px-3" to="/coordinator_user" v-if=" systemUserid === 3" >Sub Coordinator User </b-nav-item> -->
       
      </b-navbar-nav>

     
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAutomicvehicle/>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-none" />
     
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed >
          <sidebaradvance ></sidebaradvance>
        </AppSidebar>
      <main class="main" style="padding-right:0px">
       
        <div class="container-fluid">
          <router-view></router-view>          
        </div>
        <div id="overlay" >
          <div class="loader"></div>
          <br/>
         <span class="loading" style="color:#fff;">Loading...</span>
        </div>

      </main>
     
    </div>
   <!--  <TheFooter>
     
      <div>
       
      </div>
      <div class="ml-auto">
        
      </div>
    </TheFooter> -->
  </div>
</template>

<script>
//import nav1 from '@/_nav'
//import navfinace from '@/_navfinace'
//import navmis from '@/_navmis'
//import navshipmenttrack from '@/_navshipmenttrack'
//import navapproved from '@/_navapproved'
//import navdayclosure from '@/_navdayclosure'
//import navforspecificuser from '@/_navforspecificuser'
//import navfordarshan from '@/_navfordarshan'
import Vue from 'vue'
import sidebaradvance from '@/components/sidebaradvance'


import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownAutomicvehicle from './DefaultHeaderDropdownAutomicvehicle.vue'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    DefaultHeaderDropdownAutomicvehicle,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    sidebaradvance,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
  
    return {
      id:'',
      systemUserid:'',
      
    }
  },
  created() {  
       this.getuserdetails()
      //  console.log("process.env.VUE_APP_PUBLIC_URL",process.env.VUE_APP_PUBLIC_URL)
       
  },
  mounted(){
        this.activityWatcher();
      },
  
  computed: {
    name () {
      console.log("11111111111111111111111111111111111111",this.$route.name)
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {

     activityWatcher:function(){

    //The number of seconds that have passed
    //since the user was active.
    var secondsSinceLastActivity = 0;
// console.log("secondsSinceLastActivity",secondsSinceLastActivity);
    //Five minutes. 60 x 5 = 300 seconds.
    var maxInactivity = (60 * 20); 
// console.log("maxInactivity",maxInactivity);
    //Setup the setInterval method to run
    //every second. 1000 milliseconds = 1 second.
    setInterval(function(){
        secondsSinceLastActivity++;
        // console.log(secondsSinceLastActivity + ' seconds since the user was last active');
        //if the user has been inactive or idle for longer
        //then the seconds specified in maxInactivity
        if(secondsSinceLastActivity > maxInactivity){
            console.log('User has been inactive for more than ' + maxInactivity + ' seconds');
            localStorage.setItem('userData', '')
            localStorage.setItem('activeTime', '')
            localStorage.setItem('Coduser', '')
            
             // window.location.href("/ftl/login");
            // this.$router.push('/login')
            //Redirect them to your logout.php page.
            let checkPath=process.env.VUE_APP_PUBLIC_URL=='/ftl/'?'/ftl/login':'/login'
            window.location.reload(checkPath);
            // return false;
            // window.location.href("/ftl/login");
        }
    }, 1000);

    //The function that will be called whenever a user is active
    function activity(){
        //reset the secondsSinceLastActivity variable
        //back to 0
        secondsSinceLastActivity = 0;
        // console.log("secondsSinceLastActivity",secondsSinceLastActivity);
    }

    //An array of DOM events that should be interpreted as
    //user activity.
    var activityEvents = [
        'mousedown', 'mousemove', 'keydown',
        'scroll', 'touchstart'
    ];
// console.log("activityEvents",activityEvents);
    //add these events to the document.
    //register the activity function as the listener parameter.
    activityEvents.forEach(function(eventName) {
        document.addEventListener(eventName, activity, true);
    });


},


    getuserdetails: function() {
      var userData = localStorage.getItem('userData')
      // console.log("lllllllllllllllll",userData);
      if (userData) {
        var userInfo = JSON.parse(userData)
         //console.log('coddd',userInfo);
       this.systemUserid=userInfo.user_type;    
 
        this.adminuser=userInfo.userfirstname+' '+userInfo.userlastname;
          
          
        this.id = userInfo.sysusermasterid;
      } 
      else {
        this.$router.push('/login')
      }
    }
  }
};
</script>
<style>

.table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before{
  float: none!important;
}

.breadcrumb{
      margin-bottom: 0px;
}
.app-header .navbar-brand {
  left: 32%!important;
}
.app-header .nav-item .nav-link{
      padding-right: 30px;
}
.sidebar{
  /* position: fixed !important;
    z-index: 0 !important;*/
    background: #17a2b8!important;
  }
  .sidebar .nav-link .nav-icon{
    color: #fff!important;
  }
  .sidebar .nav-link:hover {
    background: #ECEFF1!important;
    color: #333!important;
  }
  .sidebar .nav-link.active{
    background: #f09642!important;
  }
  .table thead, .table thead tr {
    background: #ECEFF1 !important;
    word-wrap: break-word;
}
 .table thead, .table thead tr:hover {
    background: #ECEFF1 !important;
}
.table th, .table td {
    padding: .5rem!important;
    vertical-align: top!important;
}
.table {
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}
.card{
      word-wrap: break-word!important;
}
.table-striped tbody tr:nth-of-type(odd) {
     background-color: #fff !important;
}
.sidebar .nav-dropdown{
    background: #17a2b8!important;
}
.ps:hover>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
    background-color: #17a2b8!important;
}
.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y {
   background-color: #f09642!important;
    display: block !important;
  }
  .ps>.ps__scrollbar-y-rail {
    display: block !important;
  }
  .table.b-table > thead > tr > th[aria-sort][aria-sort="ascending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="ascending"]::after, 
  .table.b-table > thead > tr > th[aria-sort][aria-sort="descending"]::after, .table.b-table > tfoot > tr > th[aria-sort][aria-sort="descending"]::after,
  .table.b-table > thead > tr > th[aria-sort]::after, .table.b-table > tfoot > tr > th[aria-sort]::after{
    font-size: 25px;
    padding-bottom: 0 !important;
  }
  .col-form-label{
        font-weight: bold;

  }
  .sidebar .nav-dropdown-toggle::after{
        -webkit-transform: rotate(-50deg) !important;

  }
  .sidebar .nav-dropdown.open > .nav-dropdown-toggle::before{
        -webkit-transform: rotate(45deg)!important;
  }

.table tr th {
  color: #333 !important;
}
.main .container-fluid {
    padding: 0 0px!important;
}
.wing{
  width: 20%
}
.v-sidebar-menu .vsm--scroll-wrapper {
    height: 100% !important;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    width: 220px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
#overlaymodel {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .modelloader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

#listloader{
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.listloader{
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/*
.card {
   margin-bottom: 0px!important;

}*/
</style>